export default {
  path: 'eligiblestudentsbyentity',
  component: () =>
    import('@/views/general-reports/eligible-students-by-entity/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'eligiblestudentsbyentity',
      component: () =>
        import('@/views/general-reports/eligible-students-by-entity/Main.vue'),
    },
  ],
}
